export default __webpack_public_path__ + "src/images/packages/kruger-sunset-lodge/d02b99045c568148d18c9eab384bb629-3.jpg";